import { useState } from "react";
import ReactVisibilitySensor from "react-visibility-sensor";
import { Mixpanel } from "./Mixpanel";

export default function WidgetViewed({ eventName, data, children, isImportant = false }) {
    const [shown, setShown] = useState(false);
    const onChange = async (e) => {
        if (e && !shown && isImportant) {
            setShown(true);
            Mixpanel.track(eventName, data);
        }
    };
    return <ReactVisibilitySensor onChange={onChange}>{children}</ReactVisibilitySensor>;
}
